export default "__VITE_ASSET__C0ITLj1n__"